import { connect } from 'react-redux';

import TagFilterPool from 'components/molecules/TagFilter/location/TagFilterPool';
import { TagFilterPoolContainerPropsType } from 'components/molecules/TagFilter/location/TagFilterPool';
import { getActiveOverlayRef, getFilters, getProgramItemRef } from 'store/transientPoolState';
import { PoolEnumType } from 'types/services/magnolia/enums/PoolEnum';

// type RootStateType = TransientPoolStateType;

type OwnPropsType = {
	selectedPool: PoolEnumType;
};

const mapStateToProps = (state: any, ownProps: any): TagFilterPoolContainerPropsType => {
	const filters = ownProps.selectedPool ? getFilters(state, ownProps.selectedPool) : {};

	return {
		filters,
		programItemRef: getProgramItemRef(state),
		activeOverlayRef: getActiveOverlayRef(state),
	} as any;
};

export default connect<ReturnType<typeof mapStateToProps>, {}, OwnPropsType>(mapStateToProps)(TagFilterPool);
